<script setup lang="ts">
import { useGeoDataStore } from '~/stores/geoData'

const props = defineProps<{ modelValue: string | null }>()
const emit = defineEmits(['update:modelValue'])

const geoDataStore = useGeoDataStore()
onMounted(() => {
  geoDataStore.initCounties()
})
const countiesOptions = computed(() =>
  geoDataStore.counties.map((county) => ({ label: county.name, value: county.county_code }))
)
const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
<template>
  <Dropdown
    v-model="value"
    :options="countiesOptions"
    option-label="label"
    option-value="value"
    placeholder="Välj län"
    aria-label="Välj län"
    show-clear
  />
</template>
